import React from 'react';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import { Section as BaseSection } from '../../styled-components';

import why1 from '../../images/why-1.png';
import why2 from '../../images/why-2.png';
import why3 from '../../images/why-3.png';
import nasaImg from '../../images/nasa.jpg'; // tu imagen de fondo

// 🔧 Sección personalizada con imagen y overlay
const Section = styled(BaseSection)`
  position: relative;
  background-image: url(${nasaImg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #000;

  &::before {
    content: "";
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0); /* Más oscuro que 0.5 */
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1; /* Para que el contenido esté por encima */
  }
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  margin-top: 4rem;
  color: black;
  font-size: 2.5rem;
  @media(min-width: 768px){
    max-width: 50%;
  }
`;

const Red = styled.span`
  color: ${props => props.theme.primaryColor};  
`;

const InfoCont = styled.div`
  display: flex;
  margin-top: -2rem;
  margin-bottom: 3rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Paragraph = styled.h6`
  font-size: 1.3rem;
  color: black;
  text-align: center;
  margin-bottom: 0rem;
  margin-top: 3rem;
  width: 70%;
`;

const ExtraCont = styled.ul`
  list-style: none;
  margin: 3rem 0 5rem;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 100%;
  flex-direction: column;
  @media(min-width: 768px){
    flex-direction: row;
  }
`;

const ExtraItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
  @media(min-width: 768px){
    width: 25%;
    margin-bottom: 0rem;
  }
`;

// 🔍 Imagen con efecto zoom al pasar el mouse
const Icon = styled.img`
  max-width: 270px;  /* 150% del tamaño original de 80px */
  min-height: 215px;
  margin-bottom: 2rem;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1); /* zoom suave al pasar el mouse */
  }
`;

const ExtraInfo = styled.p`
  text-align: center;
  color: black;
  font-size: 1.4rem;
`;

const Bold = styled.span`
  font-weight: bold;
`;

export default () => {
  return (
    <Section>
      <Container>
        <InfoCont>
          <br />
          <br />
          <Title>
            Somos <Red>propietarios</Red> como <Red>TÚ</Red> 
          </Title>
          <Paragraph>
            GESTIONAMOS TU BIEN RAIZ Y TE ASESORAMOS PARA HACER CRECER TU PATRIMONIO
          </Paragraph>        
        </InfoCont>
        <ExtraCont>
          <ExtraItem>
            <Icon src={why1} alt="" />
            <ExtraInfo>
              Centrados en tus necesidades.
            </ExtraInfo>
          </ExtraItem>
          <ExtraItem>
            <Icon src={why2} alt="" />
            <ExtraInfo>
              Te acompañamos en todo el viaje.
            </ExtraInfo>
          </ExtraItem>
          <ExtraItem>
            <Icon src={why3} alt="" />
            <ExtraInfo>
              Ponemos la tecnología a tu servicio.
            </ExtraInfo>
          </ExtraItem>                    
        </ExtraCont> 
        <br />
      </Container>
    </Section>
  );
};